import { BrowserRouter as Router } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./pages/HeaderSection/Header";
import About from "./pages/AboutSection/About";
import Marketing from "./pages/MarketingSection/Marketing";
import Services from "./pages/ServicesSection/Services";
import DoctorJourney from "./pages/DoctorsJourney/DoctorJourney";
import Testimonials from "./pages/TestimonialsSection/Testimonials";
import Partners from "./pages/PartnersSection/Partners";
import BookConsultation from "./pages/BookConsultation/BookConsultation";
import Footer from "./pages/FooterSection/Footer";

function App() {
  return (
    <Router>
      <Header />
      <main>
        <Home id="home" />
        <About id="about" />
        <Marketing id="Vision&Goals" />
        <DoctorJourney />
        <Services id="services" />
        <Testimonials id="Testimonials" />
        <Partners />
        <BookConsultation id="BookConsultation" />
      </main>
      <Footer />
    </Router>
  );
}

export default App;
